<template>
    <b-modal title="Remove Tags" id="remove-tags-popup" size="sm">

        <multiselect
            v-model="tags"
            :multiple="true"
            :options="tagsList"
            select-label=""
            deselect-label=""
            label="name"
            track-by="name"
            class="multiselect-mid"
        >
        </multiselect>

        <template #modal-footer>
            <span v-if="loading"><b-spinner class="mr-1" small></b-spinner>Loading...</span>
            <b-button v-else :disabled="!tags.length" variant="primary" size="lg" @click="add">Remove</b-button>
        </template>
    </b-modal>
</template>

<script>

import multiselect from "vue-multiselect";

export default {

    components: {
        multiselect,
    },

    props: {
        tagsList: Array
    },

    data() {
        return {
            loading: false,
            tags: [],
        }
    },

    methods: {
        open() {
            this.loading = false
            this.tags = []
            this.$bvModal.show('remove-tags-popup')
        },

        close() {
            this.loading = false
            this.$bvModal.hide('remove-tags-popup')
        },

        add() {
            this.loading = true
            this.$emit('removeTags', this.tags)
        },
    }
}
</script>